export default "__VITE_ASSET__b157dce8__"